/**
 * 模組頁面代碼 : 1430-UI-02
 * 頁面說明 : 部門列表畫面
 * @module web/modules/department/components/DepartmentModal
 */

// ----- import from npm modules ----
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

// ----- import from local modules -----
import enumList from 'web/utils/enumList';
import {BaseComponent} from 'web/components/BaseComponent';
import {addPosition, editPosition} from 'web/redux/actions/PositionActions';

// ----- constants -----
import {TITLE_DEPARTMENT_EDIT, TITLE_POSITION_NEW} from 'web/constant';
import {showMessage} from 'web/utils/modalHelper';
import {useSelector} from 'react-redux';

const PositionModal = React.forwardRef((props, ref) => {
  const {onPosition, reloadPositionList, mode, setNeedEmployeeLoad} = props;
  const dispatch = useDispatch();
  const currentSelect = useSelector(
    (state) => state.position.positionSelection.data,
  );

  useEffect(() => {
    if (mode === enumList.modalMode.edit && currentSelect) {
      setFormValues({
        modalPositionCode: currentSelect.positionCode,
        modalPositionName: currentSelect.positionName,
        modalPositionDescription: currentSelect.description,
        modalPositionId: currentSelect.positionId,
      });
    }
  }, [currentSelect]);

  const baseComponent = new BaseComponent(props);
  const [formValues, setFormValues] = useState({
    modalPositionId: 0,
    modalPositionCode: '',
    modalPositionName: '',
    modalPositionDescription: '',
  });
  const [invalidShow, setInvalidShow] = useState('none');
  const modalIcon = mode === enumList.modalMode.new ? '#ico-plus' : '#ico-edit';
  const modalTitleText =
    mode === enumList.modalMode.new
      ? TITLE_POSITION_NEW
      : TITLE_DEPARTMENT_EDIT;

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    // 檢查表單是否驗證通過
    if (form.checkValidity() === false) {
      setInvalidShow('block');
      return;
    }
    form.classList.add('was-validated');

    const req = {
      positionId: formValues.modalPositionId,
      positionCode: formValues.modalPositionCode,
      positionName: formValues.modalPositionName,
      description: formValues.modalPositionDescription,
    };
    if (mode === enumList.modalMode.edit) {
      submitEditPosition(req);
    }
    if (mode === enumList.modalMode.new) {
      submitAddPosition(req);
    }
    form.classList.remove('was-validated');
    resetForm();
    setNeedEmployeeLoad(true);
  };

  const submitAddPosition = (req) => {
    dispatch(addPosition(req)).then((res) => {
      const statusCode = res.payload.code;
      if (statusCode && statusCode.isSuccessCode()) {
        onPosition();
        reloadPositionList();
      } else {
        toggleDepartmentAddModal(false);
        showMessage(
          enumList.messageModalMode.error,
          'error',
          res.payload.message,
        );

        console.error('fetchDepartmentList error', res);
      }
    });
  };
  const submitEditPosition = (req) => {
    dispatch(editPosition(req)).then((res) => {
      const statusCode = res.payload.code;
      if (statusCode && statusCode.isSuccessCode()) {
        const departmentList = res.payload.result;
        onPosition();
        reloadPositionList();
      } else {
        // toggleDepartmentEditModal(false);
        showMessage(
          enumList.messageModalMode.error,
          'error',
          res.payload.message,
        );
      }
    });
  };

  // Handle change event
  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;

    setFormValues({
      ...formValues,
      [target.name]: value,
    });
  };

  const resetForm = () => {
    setFormValues({
      modalDepartmentCode: '',
      modalDepartmentName: '',
    });
  };

  return (
    <div
      ref={ref}
      className="modal fade"
      id="modalPosition"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="modalPositionLabel"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <form
          className="modal__form modal-content needs-validation"
          id="modalAccountForm"
          noValidate
          onSubmit={handleSubmit}
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalAccountLabel">
              <div className="modal__title__badge">
                <svg className="badge__icon" aria-hidden="true">
                  <use href={modalIcon}></use>
                </svg>
              </div>
              <div className="modal__title__text">{modalTitleText}</div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => setTimeout(() => resetForm(), 300)}
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column gap-3 px-2">
              <div className="modal__form__catagory row">
                <div className="col-3">
                  <div className="modal__form__catagory__lable">職位資訊</div>
                </div>
                <div className="col-9">
                  <div className="row">
                    <div className="col-6">
                      <label htmlFor="modalPositionCode" className="form-label">
                        職位代號*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalPositionCode"
                        name="modalPositionCode"
                        value={formValues.modalPositionCode || ''}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalPositionName" className="form-label">
                        職位名稱*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalPositionName"
                        name="modalPositionName"
                        value={formValues.modalPositionName || ''}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-12">
                      <label
                        htmlFor="modalPositionDescription"
                        className="form-label"
                      >
                        職位描述
                      </label>
                      <textarea
                        className="form-control"
                        id="modalPositionDescription"
                        name="modalPositionDescription"
                        value={formValues.modalPositionDescription || ''}
                        onChange={handleChange}
                        rows="2"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div
                    className="alert alert-warning global-invalid-feedback"
                    style={{display: invalidShow}}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-cancel"
              onClick={() => setTimeout(() => resetForm(), 300)}
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button type="submit" className="btn btn-primary">
              儲存
            </button>
          </div>
        </form>
      </div>
    </div>
  );
});

export default PositionModal;
